export default __webpack_public_path__ + "static/media/BA3.7aa3afb2.jpg";